/**
 * Webpack code-splitting failures (stale deploy, bad browser cache, offline, etc.).
 * Not application logic bugs — separate in monitoring and user messaging.
 */
export function isChunkLoadError(error) {
    if (!error) return false;
    if (error.name === 'ChunkLoadError') return true;
    const msg = error.message;
    if (typeof msg === 'string' && /Loading chunk [\w-]+ failed/i.test(msg)) return true;
    return false;
}

/** Best-effort cache clear then full reload (helps ERR_CACHE_READ_FAILURE / stale chunks). */
export async function clearWebCachesAndReload() {
    try {
        if (typeof caches !== 'undefined' && typeof caches.keys === 'function') {
            const keys = await caches.keys();
            await Promise.all(keys.map((key) => caches.delete(key)));
        }
    } catch (_) {
        // ignore
    }
    window.location.reload();
}
